// import { useEffect } from 'react'

// export function useDebounceEffect(
//   fn,
//   waitTime,
//   deps,
// ) {
//   useEffect(() => {
//     const t = setTimeout(() => {
//       fn.apply(undefined, deps)
//     }, waitTime)

//     return () => {
//       clearTimeout(t)
//     }
//   }, deps)
// }


import { useEffect, DependencyList, EffectCallback } from 'react';

/**
 * A custom hook that debounces a React effect.
 * The effect function `fn` will only be called after `waitTime` milliseconds
 * have passed without any changes in the `deps` array.
 *
 * @template T The type of the dependencies array.
 * @param {EffectCallback} fn The effect function to debounce.
 * @param {number} waitTime The debounce wait time in milliseconds.
 * @param {T} deps The dependency array for the effect.
 */
export function useDebounceEffect<T extends DependencyList>(
  fn: (...args: T) => EffectCallback | void, // Accepts args from deps, returns cleanup or void
  waitTime: number,
  deps: T,
): void {
  useEffect(() => {
    const timeoutId = setTimeout(() => {

      const cleanup = fn(...deps);


      if (typeof cleanup === 'function') {
 
        return cleanup;
      }

      return undefined;
    }, waitTime);


    return () => {
      clearTimeout(timeoutId);
      
    };
  }, [...deps, waitTime]); 
}
